import { render, staticRenderFns } from "./e-number2.vue?vue&type=template&id=6d357d4a&scoped=true"
import script from "./e-number2.vue?vue&type=script&lang=js"
export * from "./e-number2.vue?vue&type=script&lang=js"
import style0 from "./e-number2.vue?vue&type=style&index=0&id=6d357d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d357d4a",
  null
  
)

export default component.exports